import { Component, OnInit } from '@angular/core';
import { CultivoViewModel } from '../../../cultivos/cultivo.types';
import { TwAforoCultivoCamViewModel, TwCorteCultivoCamViewModel, TwUnidadInspeccionViewModelExtended } from '../../unidad-inspeccion-datosbasicos.types';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { tap, catchError, of } from 'rxjs';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { CodigoConfeccionItemViewModel } from 'src/app/components/_mantenimiento/registros/codigosconfeccion/codigoconfeccion.types';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CodigoConfeccionService } from 'src/app/components/_mantenimiento/registros/codigosconfeccion/codigoconfeccion.service';
import { AforoCultivoCamService } from '../../aforo-cultivo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UnidadInspeccionService } from '../../unidad-inspeccion.service';
import { ForeignKeyValidator } from 'src/app/components/core/_infrastructure/classes/foreignKeyValidator';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import { NavMenuService } from 'src/app/components/core/components/navmenu/navmenu.service';
import { ConfirmationService } from 'primeng/api';
import { CorteCultivoCamService } from '../../corte-cultivo.service';
import { PeriodoPlazoService } from 'src/app/components/_mantenimiento/campanias/periodos/plazos/plazos.service';
import { ListaPlazosPeriodoCamViewModel } from 'src/app/components/_mantenimiento/campanias/periodos/plazos/plazos.types';
import { EnumIdsTcTipoSolicitudCam } from '../../../types/enum';
import { RecintoUnidadInspeccionItemViewModel } from '../../../buscadores/unidades-inspeccion/buscador-unidad-inspeccion.types';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-inspeccion-ui-aforo-corte-wrapper-edit',
    templateUrl: './inspeccion-ui-aforo-corte-wrapper-edit.component.html',
    styleUrls: ['./inspeccion-ui-aforo-corte-wrapper-edit.component.scss'],
})
export class InspeccionUiAforoCorteWrapperEditComponent extends ComponentBase implements OnInit {
    visibilitySpinnerGuardando = false;
    formGroup: FormGroup;
    cultivos: CultivoViewModel[];
    almacenes: CodigoConfeccionItemViewModel[];
    aforosDeCultivo: TwAforoCultivoCamViewModel[];
    corte: TwCorteCultivoCamViewModel;
    unidadInspeccion: TwUnidadInspeccionViewModelExtended;
    recintoUnidadInspeccionList: RecintoUnidadInspeccionItemViewModel[];
    listaPlazosPeriodo: ListaPlazosPeriodoCamViewModel;
    fechaInicioExportacionVigente: Date | null;
    habilitadaExportacion = false;

    private aforoListUrl = 'campanias/unidadinspeccion/aforosycortes';
    private aforoCreationSuccess = 'Aforo creado correctamente';
    private aforoUpdateSuccess = 'Aforo actualizado correctamente';
    private corteCreationSuccess = 'Corte/Autorización (Kgs.), creada correctamente';
    private corteUpdateSuccess = 'Corte/Autorización (Kgs.), actualizado correctamente';

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const IdUi = params.get('idUi');
        if (IdUi) {
            this.getUnidadInspeccion(parseInt(IdUi));
        }
        const id: any = params.get('id');
        if (id) {
            this.getCorte(id);
        }
    });

    private currentYear = new Date().getFullYear();
    private currentMonth = new Date().getMonth() + 1;

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private unidadInspeccionService: UnidadInspeccionService,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private almacenesService: CodigoConfeccionService,
        private aforoCultivoService: AforoCultivoCamService,
        private corteCultivoService: CorteCultivoCamService,
        private periodoPlazoService: PeriodoPlazoService,
        public decimalPipe: DecimalPipe,
        private navMenuService: NavMenuService,
        private router: Router,
        private confirmationService: ConfirmationService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            Id: [null],
            IdCultivo: [null, Validators.compose([Validators.required, ForeignKeyValidator.cannotBeNullOrZero])],
            CodigoSigPacRecinto: [{ value: null, disabled: true }], // readonly
            IdentificadorCultivo: [{ value: null, disabled: true }], // readonly
            IdAforo: [null, Validators.compose([Validators.required, ForeignKeyValidator.cannotBeNullOrZero])], // Bolsa Productiva
            SuperficieVariedad: [{ value: null, disabled: true }], // readonly
            ProduccionEstimada: [{ value: null, disabled: true }], // readonly (la indicada por el operador al crear el cultivo)
            ProduccionAforada: [{ value: null, disabled: true }, Validators.compose([Validators.required])], // Bolsa Productiva -- KgsProduccionEstimada
            ProduccionReal: [{ value: null, disabled: true }], // readonly // Este valor se actualiza en las solicitudes de exportación -- KgsProduccionReal
            KgsAcumuladosCorte: [{ value: null, disabled: true }], // readonly
            Corte: [null, Validators.compose([Validators.required])], // Kgs. autorizados
            IdAlmacen: [null, Validators.compose([Validators.required, ForeignKeyValidator.cannotBeNullOrZero])],
            Exportador: [null],
            FechaCaducidad: [null],
            FechaInicioExportacion: [{ value: null, disabled: true }],
            FechaFinPeriodo: [{ value: null, disabled: true }],
        });

        this.form = this.formGroup;
    }

    /**
     * Se cargan los datos de la unidad de inspección y sus recintos "PI-A-Ed" asociados
     * Una vez obtenida, establece el valor para la propiedad readonly a partir de la información del usuario y los permisos de edición.
     * Después invoca al servicio de obtención de inspecciones de la U.I.
     * @param id number
     */
    private getUnidadInspeccion(id: number): void {
        this.unidadInspeccionService
            .getUI(id)
            .pipe(
                tap((udInspeccion: TwUnidadInspeccionViewModelExtended) => {
                    // Una UI existente deberá tener al menos un recinto "PI-A-Ed".
                    if (!udInspeccion?.FirstRecinto) {
                        // No debería pasar por aquí, porque cuando se eliminan todos los recintos "PI-A-Ed" de una UI, se elimina además la UI
                        return;
                    }
                    this.unidadInspeccion = udInspeccion;
                    this.onUnidadInspeccionLoaded();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    private onUnidadInspeccionLoaded(): void {
        this.navMenuService.updateMenuServiceForUdInspeccion(
            this.unidadInspeccion.IdUi!,
            this.unidadInspeccion.IdEstadoUi!,
            this.unidadInspeccion.FirstRecinto?.IdTipoSolicitudCam || 0,
            this.unidadInspeccion.PeriodoCertificaKgs,
        );
        this.getRecintosUiByIdUi(this.unidadInspeccion.IdUi!);
        this.getPlazos(this.unidadInspeccion.FirstRecinto.IdPeriodo); // Cargamos los plazos del periodo.
        this.loadAlmacenes(this.unidadInspeccion.FirstRecinto.IdPeriodo, this.unidadInspeccion.FirstRecinto.IdCampania);
    }

    private getRecintosUiByIdUi(idUi: number): void {
        this.unidadInspeccionService
            .getRecintosUiByIdUi(idUi)
            .pipe(
                tap(res => {
                    this.recintoUnidadInspeccionList = res;
                    this.buildCultivosList(this.recintoUnidadInspeccionList);
                }),
            )
            .subscribe();
    }

    /**
     * Obtenemos los plazos del periodo, para saber si hay alguno que ya haya empezado.
     * Si hay alguno empezado se deshabilitado el campo ControlProduccionExportacion.
     * @param idPeriodo number
     */
    private getPlazos(idPeriodo: number): void {
        this.periodoPlazoService
            .getListaPlazosDePeriodo(idPeriodo)
            .pipe(
                tap((results: ListaPlazosPeriodoCamViewModel) => {
                    this.listaPlazosPeriodo = results;
                    this.fechaInicioExportacionVigente = this.getFechaInicioExportacion(this.unidadInspeccion.FirstRecinto.IdTipoSolicitudCam!);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    private getCorte(idCorte: number): void {
        this.corteCultivoService
            .getCorteById(idCorte)
            .pipe(
                tap((corte: TwCorteCultivoCamViewModel) => {
                    this.corte = corte;
                    this.setValidacionesEdicionForm();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    private setValidacionesEdicionForm(): void {
        if (this.readonly) {
            this.formGroup.disable();
            return;
        }
        this.removeValidators('IdCultivo');
        this.formGroup.controls['IdCultivo'].disable();
    }

    /**
     * Guardamos la fecha del primer plazo de exportación más reciente, en función del tipo de solicitud.
     * @param tipoSolicitud: number
     * @returns Date | null
     */
    private getFechaInicioExportacion(tipoSolicitud: number): Date | null {
        if (!this.listaPlazosPeriodo) {
            return null;
        }
        let fechaInicioExportacion = null;

        for (let i = 0; i < this.listaPlazosPeriodo.PlazoPeriodoCollection.length; i++) {
            const plazoPeriodo = this.listaPlazosPeriodo.PlazoPeriodoCollection[i];
            if (plazoPeriodo) {
                switch (tipoSolicitud) {
                    case EnumIdsTcTipoSolicitudCam.ID_CONFECCION:
                        this.habilitadaExportacion = plazoPeriodo.HabilitadaExportacionAlmacenes;
                        if (plazoPeriodo.FechaInicioExportacionConfeccion) {
                            const fiEC = new Date(plazoPeriodo.FechaInicioExportacionConfeccion);
                            if (fechaInicioExportacion === null) {
                                fechaInicioExportacion = fiEC;
                                break;
                            }
                            if (fiEC < fechaInicioExportacion) {
                                fechaInicioExportacion = fiEC;
                                break;
                            }
                        }
                        break;
                    case EnumIdsTcTipoSolicitudCam.ID_EMPRESA_DESHIDRATACION:
                        this.habilitadaExportacion = plazoPeriodo.HabilitadaExportacionEmpDeshidratadoras;
                        if (plazoPeriodo.FechaInicioExportacionEmpDeshidratadoras) {
                            const fiEED = new Date(plazoPeriodo.FechaInicioExportacionEmpDeshidratadoras);
                            if (fechaInicioExportacion === null) {
                                fechaInicioExportacion = fiEED;
                                break;
                            }
                            if (fiEED < fechaInicioExportacion) {
                                fechaInicioExportacion = fiEED;
                                break;
                            }
                        }
                        break;
                    case EnumIdsTcTipoSolicitudCam.ID_INVERNADERO:
                        this.habilitadaExportacion = plazoPeriodo.HabilitadaExportacionInvernaderos;
                        if (plazoPeriodo.FechaInicioExportacionInvernadero) {
                            const fiEI = new Date(plazoPeriodo.FechaInicioExportacionInvernadero);
                            if (fechaInicioExportacion === null) {
                                fechaInicioExportacion = fiEI;
                                break;
                            }
                            if (fiEI < fechaInicioExportacion) {
                                fechaInicioExportacion = fiEI;
                                break;
                            }
                        }
                        break;
                    case EnumIdsTcTipoSolicitudCam.ID_PARCELA:
                        this.habilitadaExportacion = plazoPeriodo.HabilitadaExportacionParcelas;
                        if (plazoPeriodo.FechaInicioExportacionParcela) {
                            const fiEP = new Date(plazoPeriodo.FechaInicioExportacionParcela);
                            if (fechaInicioExportacion === null) {
                                fechaInicioExportacion = fiEP;
                                break;
                            }
                            if (fiEP < fechaInicioExportacion) {
                                fechaInicioExportacion = fiEP;
                                break;
                            }
                        }
                        break;
                }
            }
        }
        return fechaInicioExportacion;
    }

    /**
     * Comprobamos si la fecha de caducidad del código de autorización no es posterior a la fecha de inicio de exportación del tipo de solicitud correspondiente
     * Se comprueba que la fecha de caducidad no sea anterior a la fecha-inicio-exportacion
     * @returns void
     */
    private checkFechaCaducidadYPlazoVigente(fechaCaducidad: Date): boolean {
        if (!this.listaPlazosPeriodo) {
            return false;
        }
        const periodoFechaFin = new Date(this.listaPlazosPeriodo.PeriodoFechaFin!);
        if (fechaCaducidad > periodoFechaFin) {
            this.addErrorMessage('La fecha de caducidad no puede ser superior a la fecha fin del periodo');
            this.setCustomError('FechaCaducidadFueraDePeriodo', 'FechaCaducidad');
            return false;
        }
        this.removeCustomError('FechaCaducidadFueraDePeriodo', 'FechaCaducidad');

        if (this.habilitadaExportacion && this.fechaInicioExportacionVigente) {
            if (fechaCaducidad < this.fechaInicioExportacionVigente!) {
                this.addErrorMessage('La fecha de caducidad no puede ser anterior al plazo de exportación vigente');
                this.setCustomError('FechaCaducidadFueraPlazo', 'FechaCaducidad');
                return false;
            }
        }

        this.removeCustomError('FechaCaducidadFueraPlazo', 'FechaCaducidad');
        return true;
    }

    private buildCultivosList(recintos: RecintoUnidadInspeccionItemViewModel[]): void {
        this.cultivos = [];
        for (let i = 0; i < recintos.length; i++) {
            let recintoCultivo: RecintoUnidadInspeccionItemViewModel = recintos[i];
            this.addCultivoToList(recintoCultivo);
        }
    }

    /**
     * Esta función permite crear la lista con todos los cultivos distintos que hay en todos los recintos de la U.I..
     * La lista de cultivos se crea de tal forma, que no se incluye repetido un cultivo que pudiera estar en distintos recintos-ui.
     * No debería estar el mismo cultivo en distintos recintos-UI de la misma UI, pero se controla.
     * @param recintoCultivo TwRecintoCultivosViewModel
     * @returns void
     */
    private addCultivoToList(recintoCultivo: RecintoUnidadInspeccionItemViewModel): void {
        if (!recintoCultivo || !recintoCultivo.Cultivo) {
            // @author: No debería ocurrir que llegara un recinto tal a una U.I., pero aún así se controla.
            return;
        }
        const cultivoAlreadyAdded = this.cultivos.find(cultivo => cultivo.Id === recintoCultivo.Cultivo.Id);
        if (cultivoAlreadyAdded) {
            return;
        }
        this.cultivos = [...this.cultivos, recintoCultivo.Cultivo]; // Usamos spread operator para que el OnChanges en el componente "hijo" se entere.
    }

    onCultivoSelected(cultivoSelected: CultivoViewModel): void {
        if (!cultivoSelected) {
            this.aforosDeCultivo = [];
            this.almacenes = [];
            this.onAforoCultivoSelected(undefined);
            return;
        }
        this.loadAforosDeCultivo(cultivoSelected);
    }

    /**
     * Obtenemos la lista de aforos del cultivo, que se usará en el desplegable.
     * @param cultivoSelected CultivoViewModel
     */
    private loadAforosDeCultivo(cultivoSelected: CultivoViewModel): void {
        this.aforoCultivoService
            .getAforosByIdCultivo(cultivoSelected.Id)
            .pipe(
                tap((aforosDeCultivo: TwAforoCultivoCamViewModel[]) => {
                    this.aforosDeCultivo = aforosDeCultivo;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Se obtienen la lista de almacenes que cumpla:
     * - Se buscan almacenes de solicitudes aceptadas en el periodo.
     * - Estos almacenes tendrán que:
     *      - estar activos
     *      - no estar desautorizados en la misma campaña que la inspección
     *      - no estar en una UI dada de baja o rechazada en el periodo.
     * - A partir de éstas solicitudes se obtienen los almacenes y se devuelven.
     * - Este mismo método se aplica en el componente SolicitudCamEnvioWrapperComponent
     */
    private loadAlmacenes(idPeriodo: number, idCampania: number): void {
        this.almacenesService
            .getAlmacenesAceptadosByIdPeriodo(idPeriodo, idCampania)
            .pipe(
                tap((almacenes: CodigoConfeccionItemViewModel[]) => {
                    this.almacenes = almacenes;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    onAforoCultivoSelected(item: TwAforoCultivoCamViewModel | undefined): void {
        if (this.readonly) {
            return;
        }
        if (item) {
            this.form.controls['ProduccionAforada'].enable();
        } else {
            this.form.controls['ProduccionAforada'].disable();
        }
    }

    onCreateAforo(): void {
        const aforo = this.createAforoCultivoViewModel();
        this.confirmationService.confirm({
            message: `Se va a crear el aforo '${aforo.Descripcion}', \npara el cultivo seleccionado, \ncon una producción estimada de ${this.decimalPipe.transform(aforo.KgsProduccionEstimada, '1.0-3', 'es')} Kgs., ¿es correcto?`,
            accept: () => {
                this.doSaveAforo(aforo)
                    .then(() => {
                        this.onCultivoSelected(aforo.CultivoSelected!);
                    })
                    .catch(() => {
                        // NO-OP
                    });
            },
        });
    }

    private getDescripcionNuevoAforo(payloadAforo: TwAforoCultivoCamViewModel): TwAforoCultivoCamViewModel {
        const cultivoSelected = this.cultivos.filter(c => c.Id === payloadAforo.IdCultivo)[0];
        payloadAforo.CultivoSelected = cultivoSelected;
        if (cultivoSelected) {
            payloadAforo.Descripcion = this.calculateDescripcionAforo(cultivoSelected, payloadAforo);
        } else {
            payloadAforo.Descripcion = '';
        }

        return payloadAforo;
    }

    /**
     * Construye la descripción del nuevo aforo, a partir de:
     * - la variedad del cultivo seleccionado
     * - el código sigpac del recinto al que pertenece el cultivo,
     * - el identificador del cultivo
     * - el año actual
     * - el mes en curso.
     * Formato de salida:
     * <variedad>-<sigpac>-<identificador-cultivo>-<aaaa>-<mm>
     *
     * El identificador es una letra, que se asigna al cultivo en función del número de cultivos del recinto.
     * @param cultivoSelected CultivoViewModel
     * @param payloadAforo TwAforoCultivoCamViewModel
     * @returns string
     */
    private calculateDescripcionAforo(cultivoSelected: CultivoViewModel, payloadAforo: TwAforoCultivoCamViewModel): string {
        const Month = payloadAforo.Mes.toString().padStart(2, '0');
        return `${cultivoSelected.Variedad}-${cultivoSelected.CodigoSigPacRecinto}-${cultivoSelected.Identificador}-${payloadAforo.Anyo}${Month}`;
    }

    onBack(): void {
        this.router.navigate([this.aforoListUrl, this.unidadInspeccion?.IdUi]);
    }

    /**
     * Primero se intenta actualizar los datos del aforo, en el caso que hubiera cambiado el valor del campo ProduccionAforada.
     * Después se guarda el corte.
     */
    doUpdateAforoYCorte(): void {
        const aforoSelected = { ...this.getSelectedAforo() } as TwAforoCultivoCamViewModel; // Creamos una instancia nueva del objeto para no modificar el del desplegable al modificar la propiedad KgsProduccionEstimada
        if (!aforoSelected) {
            // No debebería pasar por aquí.
            return;
        }
        aforoSelected.KgsProduccionEstimada = parseInt(this.formGroup.controls['ProduccionAforada'].value);
        this.doSaveAforo(aforoSelected, true)
            .then(() => {
                this.doSaveCorte();
            })
            .catch(() => {
                // NO-OP
            });
    }

    private validarProduccionAforada(): number {
        let valida = 0;
        const produccionAforada = parseInt(this.formGroup.controls['ProduccionAforada'].value);
        const IdCultivoSeleccionado = this.formGroup.controls['IdCultivo'].value;
        const produccionAforadaPrevia = this.aforosDeCultivo.find(aforo => aforo.IdCultivo === IdCultivoSeleccionado);
        if (produccionAforadaPrevia !== undefined) {
            if (produccionAforada < produccionAforadaPrevia.KgsProduccionEstimada) {
                this.addErrorMessage('La producción aforada deberá ser superior a la anterior: ' + produccionAforadaPrevia.KgsProduccionEstimada + ' Kgs.');
                this.setCustomError('ProduccionAforadaSuperior', 'ProduccionAforada');
                valida = -1;
            } else if (produccionAforada > produccionAforadaPrevia.KgsProduccionEstimada) {
                valida = 1;
            }
        }

        if (valida !== -1) {
            this.removeCustomError('ProduccionAforadaSuperior', 'ProduccionAforada');
        }

        return valida;
    }

    private createAforoCultivoViewModel(): TwAforoCultivoCamViewModel {
        let aforo: TwAforoCultivoCamViewModel = new TwAforoCultivoCamViewModel();
        aforo.Id = 0;
        aforo.Anyo = this.currentYear; // El año se sobreescribe en el core.
        aforo.Mes = this.currentMonth;
        aforo.IdCultivo = this.formGroup.controls['IdCultivo'].value;
        aforo = this.getDescripcionNuevoAforo(aforo);
        const cultivoSelected = this.cultivos.filter(c => c.Id === aforo.IdCultivo)[0];
        aforo.CultivoSelected = cultivoSelected;
        aforo.KgsProduccionEstimada = cultivoSelected?.ProduccionEstimada || 0;
        aforo.KgsProduccionReal = 0; // Se actualizará en la solicitud de exportación.
        return aforo;
    }

    private doSaveAforo(aforo: TwAforoCultivoCamViewModel, validarProduccion = false): Promise<any> {
        return new Promise((resolve, reject) => {
            if (validarProduccion) {
                const valido = this.validarProduccionAforada();
                if (valido === -1) {
                    reject(false);
                    return;
                }
                if (valido === 0) {
                    resolve(true); // NO ha cambiado la ProduccionAforada, así que no actualizamos el aforo
                    return;
                }
                // Si valido = 1 >> Ha indicado una ProduccionAforada superior a la anterior => se envía la core.
            }
            this.visibilitySpinnerGuardando = true;
            this.aforoCultivoService
                .saveAforo(aforo)
                .pipe(
                    tap(() => {
                        this.visibilitySpinnerGuardando = false;
                        if (aforo.Id) {
                            this.addSuccessMessage(this.aforoUpdateSuccess);
                        } else {
                            this.addSuccessMessage(this.aforoCreationSuccess);
                        }
                        resolve(true);
                    }),
                    catchError(error => {
                        this.visibilitySpinnerGuardando = false;
                        this.catchServerError(error);
                        if (error?.error?.length > 0) {
                            this.addErrorMessage(error.error[0]?.message);
                        }
                        reject(false);
                        return of(null);
                    }),
                )
                .subscribe();
        });
    }

    private doSaveCorte(): void {
        const modelCorte = { ...this.formGroup.getRawValue() };

        const valido = this.validarCorte(modelCorte);
        if (!valido) {
            return;
        }

        const corte = this.prepareCorteViewModel(modelCorte);
        this.visibilitySpinnerGuardando = true;
        this.corteCultivoService
            .saveCorte(corte)
            .pipe(
                tap(() => {
                    this.visibilitySpinnerGuardando = false;
                    if (corte.Id) {
                        this.addSuccessMessage(this.corteUpdateSuccess);
                    } else {
                        this.addSuccessMessage(this.corteCreationSuccess);
                    }
                    this.onBack();
                }),
                catchError(error => {
                    this.visibilitySpinnerGuardando = false;
                    this.catchServerError(error);
                    if (error?.error?.length > 0) {
                        this.addErrorMessage(error.error[0]?.message);
                    }
                    return of(null);
                }),
            )
            .subscribe();
    }

    private prepareCorteViewModel(modelCorteForm: any): TwCorteCultivoCamViewModel {
        const corte = new TwCorteCultivoCamViewModel();
        corte.Id = modelCorteForm.Id;
        corte.Codigo = modelCorteForm.Codigo;
        corte.IdCultivo = modelCorteForm.IdCultivo;
        corte.IdAforoCultivo = modelCorteForm.IdAforo;
        corte.IdUi = this.unidadInspeccion.IdUi!;
        corte.IdAlmacen = modelCorteForm.IdAlmacen;
        corte.KgsAutorizados = parseInt(modelCorteForm.Corte);
        corte.FechaCaducidad = modelCorteForm.FechaCaducidad ? new Date(modelCorteForm.FechaCaducidad) : undefined;
        corte.Exportador = modelCorteForm.Exportador;
        corte.IdUsuario = 0; // Este valor se sobreescribe en el core. Se inicializa por compatibilidad de tipos.
        corte.FechaCreacion = undefined; // Este valor se sobreescribe en el core. Se inicializa por compatibilidad de tipos.
        return corte;
    }

    /**
     * Comprobamos que los datos del corte, introducidos en el formulario son correctos.
     * Revisa que la suma del corte actual más los ya acumulados, no superan la producción aforada (KgsProduccionEstimada).
     *
     * @param formCorte raw value del formulario
     * @returns boolean
     */
    private validarCorte(formCorte: any): boolean {
        const corte = parseInt(formCorte.Corte);
        let kgsAcumuladosCorte = parseInt(formCorte.KgsAcumuladosCorte) + corte;
        if (kgsAcumuladosCorte > formCorte.ProduccionAforada) {
            this.addErrorMessage(
                'La suma de los cortes no puede superar la producción aforada: ' +
                    this.decimalPipe.transform(formCorte.ProduccionAforada, '1.0-3', 'es') +
                    ' Kgs.',
            );
            this.setCustomError('CorteInvalido', 'Corte');
            return false;
        }

        let fechaCaducidad = new Date(formCorte.FechaCaducidad);
        return this.checkFechaCaducidadYPlazoVigente(fechaCaducidad);
    }

    private getSelectedAforo(): TwAforoCultivoCamViewModel | undefined {
        const idAforoSelected = this.formGroup.controls['IdAforo'].value;
        if (idAforoSelected !== null && idAforoSelected !== undefined) {
            if (this.aforosDeCultivo?.length > 0) {
                const aforoSelected = this.aforosDeCultivo.find(af => af.Id === idAforoSelected);
                return aforoSelected;
            }
        }
        return undefined;
    }

    private getSelectedCultivo(): CultivoViewModel | undefined {
        const idCultivoSelected = this.formGroup.controls['IdCultivo'].value;
        if (idCultivoSelected !== null && idCultivoSelected !== undefined) {
            if (this.cultivos?.length > 0) {
                const cultivoSelected = this.cultivos.find(af => af.Id === idCultivoSelected);
                return cultivoSelected;
            }
        }
        return undefined;
    }

    /**
     * Se permite crear un aforo nuevo para el cultivo:
     * - cuando no hubiera previamente
     * - cuando habiendo aforos creados para el cultivo seleccionado, el año de ése aforo fuera distinto del actual
     */
    get disableCreateAforo(): boolean {
        const selectedAforoAnyo = this.getSelectedAforo();
        const selectedCultivo = this.getSelectedCultivo();
        let allowNuevoAforo = false;
        if (selectedCultivo !== undefined) {
            allowNuevoAforo = this.aforosDeCultivo?.length === 0 || (selectedAforoAnyo !== undefined && selectedAforoAnyo.Anyo !== this.currentYear);
        }

        return !allowNuevoAforo;
    }

    get hasCreateAforoAccess(): boolean {
        if (!this.unidadInspeccion) return false;
        const hasAccess =
            this.loggedInUser?.getAction(
                EnumCodigosTwTcAcciones.ADD_AFORO_CULTIVO_UI,
                this.unidadInspeccion.IdEstadoUi,
                this.unidadInspeccion.FirstRecinto.IdTipoSolicitudCam,
                this.unidadInspeccion.PeriodoCertificaKgs ? 1 : 0,
            ).Editable || false;
        return hasAccess && this.unidadInspeccion.FirstRecinto?.PeriodoEnPlazoVigente === true;
    }

    private get hasAddCorteAccess(): boolean {
        if (!this.unidadInspeccion) return false;
        const hasAccess =
            this.loggedInUser?.getAction(
                EnumCodigosTwTcAcciones.ADD_CORTE_UI,
                this.unidadInspeccion.IdEstadoUi,
                this.unidadInspeccion.FirstRecinto.IdTipoSolicitudCam,
                this.unidadInspeccion.PeriodoCertificaKgs ? 1 : 0,
            ).Editable || false;
        return hasAccess && this.unidadInspeccion.FirstRecinto?.PeriodoEnPlazoVigente === true;
    }

    private get hasEditCorteAccess(): boolean {
        if (!this.unidadInspeccion) return false;
        const hasAccess =
            this.loggedInUser?.getAction(
                EnumCodigosTwTcAcciones.UPDATE_CORTE_UI,
                this.unidadInspeccion.IdEstadoUi,
                this.unidadInspeccion.FirstRecinto.IdTipoSolicitudCam,
                this.unidadInspeccion.PeriodoCertificaKgs ? 1 : 0,
            ).Editable || false;
        return hasAccess && this.unidadInspeccion.FirstRecinto?.PeriodoEnPlazoVigente === true;
    }

    get hasSavingAccess(): boolean {
        return this.hasAddCorteAccess || this.hasEditCorteAccess;
    }

    get actionNotAllowed(): boolean {
        return this.visibilitySpinnerGuardando || this.formInvalid || !this.unidadInspeccion?.FirstRecinto?.PeriodoEnPlazoVigente || this.readonly;
    }

    private get formInvalid(): boolean {
        return !this.formGroup.valid || !this.formGroup.dirty || this.formGroup.pristine;
    }

    get readonly(): boolean {
        return (!this.hasAddCorteAccess && !this.hasEditCorteAccess) || (this.corte !== null && this.corte !== undefined);
    }

    get mensajeDestrio(): string {
        return 'Se aplicará un ' + this.decimalPipe.transform(this.listaPlazosPeriodo?.Dextrio, '1.0-3', 'es') + '% de destrío sobre el aforo';
    }
}
